import zhCN from './i18n/zh-CN'

export type Locale = 'zh-CN' | 'zh-TW' | 'en'

export const locales: Locale[] = ['zh-CN', 'zh-TW', 'en']

export const defaultLocale: Locale = 'zh-CN'

export type Dict = Record<string, any>

// 默认语言字典随主包内联，其余语言按需在切换时懒加载
export const defaultDict: Dict = zhCN

const dictLoaders: Record<Locale, () => Promise<{ default: Dict }>> = {
  'zh-CN': () => Promise.resolve({ default: zhCN as Dict }),
  'zh-TW': () => import('./i18n/zh-TW'),
  en: () => import('./i18n/en'),
}

export function loadDict(locale: Locale): Promise<Dict> {
  return dictLoaders[locale]().then((m) => m.default)
}

/**
 * Get nested value by path like "a.b.c"
 */
export function getByPath(obj: Dict, path: string): any {
  return path.split('.').reduce((acc: any, cur: string) => {
    if (acc && typeof acc === 'object' && cur in acc) return acc[cur]
    return undefined
  }, obj)
}
